import React from "react";
import TrackingUtils from "@tracking/utils/TrackingUtils";
import { useAppDispatch, useAppSelector } from "app/store";
import * as Actions from "app/user-setup/store/userSetup.actions";
import { SavePathUserBody } from "app/user-setup/store/models";
import { selectStateAuth } from "app/auth/store/auth.slice";
import moment from "moment";

const initialState = {
  dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
  campos: [
    {
      nomeCampo: "",
      conteudoCampo: "",
    },
  ],
  path: {
    tela: "",
    aba: "",
  },
};

const inUndefined = (obj) => obj.conteudoCampo !== undefined;

const stringValidate = (content) => content || "";

const verifyTypeAndReturnString = (field) => TrackingUtils.transformFieldContent(field, stringValidate);

const useSavePathUser = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectStateAuth);
  const [fieldVisibility, setFieldVisibility] = React.useState(false);
  const [userPath, setUserPath] = React.useState<SavePathUserBody>({
    ...initialState,
    usuario: `${user?.name} - ${user?.username}`,
  });

  React.useEffect(() => {
    if (!fieldVisibility) return;
    if (userPath.campos.every(inUndefined)) {
      const campos = userPath.campos.map((campo) => ({
        ...campo,
        conteudoCampo: verifyTypeAndReturnString(campo.conteudoCampo),
      }));
      dispatch(Actions.savePathUser({ ...userPath, campos }));
    }
  }, [fieldVisibility]);

  return {
    changeVisibilityField: (pathUser) => {
      setUserPath({ ...userPath, ...pathUser });
      setFieldVisibility(!fieldVisibility);
    },
    visibilityField: fieldVisibility,
  };
};
export default useSavePathUser;
